import { combineEpics } from 'redux-observable';
import { sendInvitesEpic } from './send-invites';
import { getInvitesEpic } from './get-invites';
import { cancelInvitesEpic } from './cancel-invite';
import { resendInvitesEpic } from './resend-invite';
import { acceptInvitesEpic } from './accept-invite';
import { rejectInvitesEpic } from './reject-invite';
import { getInvitesOnLoginEpic } from './get-invites-on-login';
import { getUserInvitesEpic } from './get-user-invites';
import { getRecordLabelInvitesEpic } from './get-record-label-invites';
import { actionsInviteEpic } from './actions-invite';
import { addNewOperatorInvites } from './add-new-operator-invite';

const invitesEpic = combineEpics(
  getInvitesEpic,
  sendInvitesEpic,
  cancelInvitesEpic,
  resendInvitesEpic,
  acceptInvitesEpic,
  rejectInvitesEpic,
  getInvitesOnLoginEpic,
  getUserInvitesEpic,
  getRecordLabelInvitesEpic,
  actionsInviteEpic,
  addNewOperatorInvites
);

export default invitesEpic;
